import { Either, left, right } from "fp-ts/lib/Either";
import ShiftEntity from "../../../../domain/entities/ShiftEntity";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import ShiftDto from "../../../dto/ShiftDto";

const reasingShiftApiImpl = async (_:{
        shiftId: string, newUserId: string, oldUserId: string, reason: string
    }): Promise<Either<ErrorEntity, ShiftEntity>> => {
    try {
        const relativeUrl = "/turns/admin/reasign";
        const body = {
            "turn_id": _.shiftId,
            "new_valet_id": _.newUserId,
            "old_valet_id": _.oldUserId,
            "reason": _.reason
        };
        const response = await di.get<HostApi>(HostApiName).put(relativeUrl, body);

        const parsed: ShiftEntity = ShiftDto.fromJSON(response.turn);
        return right(parsed);
    } catch (error) {
        return left(ErrorEntityFromError(error));
    }
}

export default reasingShiftApiImpl;